<template>
  <div class="signboard-page">
    <div class="container page">
      <form @submit.prevent="onSubmit(currentUser.account)">
        <fieldset :disabled="inProgress">
          <fieldset class="form-group">
            招牌名稱
            <input type="text" class="form-control" v-model="signboard.name" placeholder="招牌名稱" />
          </fieldset>
          <fieldset class="form-group">
            描述
            <input
              type="text"
              class="form-control"
              v-model="signboard.description"
              placeholder="描述"
            />
          </fieldset>
          <fieldset class="form-group">
            招牌圖示
            <b-button
              @click="cancelUpload"
              variant="link"
              size="sm"
            >移除</b-button>
            <img v-if="previewImage" :src="previewImage" class="uploading-image" />
            <img v-else :src="signboard.icon" class="uploading-image" />
            <input
              ref="uploadInput"
              type="file"
              accept="image/jpeg"
              @change="uploadImage"
            />
            <input
              type="text"
              hidden="hidden"
              class="form-control"
              v-model="signboard.icon"
              placeholder="圖示ULR"
            />
          </fieldset>
          <fieldset class="form-group">
            狀態
            <select class="custom-select" v-model="signboard.status">
              <option value="show">顯示</option>
              <option value="hide">隱藏</option>
            </select>
          </fieldset>
          <b-form-tags v-model="signboard.deliveryLocation" no-outer-focus class="mb-2">
            <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
              <b-input-group aria-controls="my-custom-tags-list">
                <input
                  v-bind="inputAttrs"
                  v-on="inputHandlers"
                  placeholder="送餐地點"
                  class="form-control">
                <b-input-group-append>
                  <b-button @click="addTag()" variant="primary">新增</b-button>
                </b-input-group-append>
              </b-input-group>
              <ul
                id="my-custom-tags-list"
                class="list-unstyled d-inline-flex flex-wrap mb-0"
                aria-live="polite"
                aria-atomic="false"
                aria-relevant="additions removals"
              >
                <b-card
                  v-for="tag in tags"
                  :key="tag"
                  :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                  tag="li"
                  class="mt-1 mr-1"
                  body-class="py-1 pr-2"
                >
                  <strong>{{ tag }}</strong>
                  <b-button
                    @click="removeTag(tag)"
                    variant="link"
                    size="sm"
                    :aria-controls="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                  >移除</b-button>
                </b-card>
              </ul>
            </template>
          </b-form-tags>
          <b-form-tags v-model="signboard.deliveryTime" no-outer-focus class="mb-2">
            <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
              <b-input-group aria-controls="my-custom-tags-list">
                <input
                  v-bind="inputAttrs"
                  v-on="inputHandlers"
                  placeholder="送餐時間"
                  class="form-control">
                <b-input-group-append>
                  <b-button @click="addTag()" variant="primary">新增</b-button>
                </b-input-group-append>
              </b-input-group>
              <ul
                id="my-custom-tags-list"
                class="list-unstyled d-inline-flex flex-wrap mb-0"
                aria-live="polite"
                aria-atomic="false"
                aria-relevant="additions removals"
              >
                <b-card
                  v-for="tag in tags"
                  :key="tag"
                  :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                  tag="li"
                  class="mt-1 mr-1"
                  body-class="py-1 pr-2 text-nowrap"
                >
                  <strong>{{ tag }}</strong>
                  <b-button
                    @click="removeTag(tag)"
                    variant="link"
                    size="sm"
                    :aria-controls="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                  >移除</b-button>
                </b-card>
              </ul>
            </template>
          </b-form-tags>
          <button
            :disabled="inProgress"
            class="btn btn-lg pull-xs-right btn-secondary"
            type="submit"
          >確定</button>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<style>
.uploading-image {
  display: flex;
}
</style>
<script>
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  name: "Signboard",
  methods: {
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log('previewImage is set');
      };
    },
    onSubmit(slug) {
      //if previewImage set , upload img and get url.
      let action = slug ? "signboardEdit" : "signboardCreate";
      if( this.previewImage !== null ){
        // console.log('previewImage upload');
        this.$store.dispatch("ImageUpload", this.$refs.uploadInput.files[0])
          .then(()=>this.$store.dispatch(action))
          .catch(err=>alert(err));
      }else{
        this.$store.dispatch(action)
      }
    },
    cancelUpload(){
      this.$refs.uploadInput.value=null;
      this.previewImage = null;
    }
  },
  async beforeRouteEnter(to, from, next) {
    store.dispatch("fetchSignboard", to.params.slug);
    return next();
  },
  data() {
    return {
      previewImage: null,
      inProgress: false,
      errors: {}
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["signboard", "currentUser"])
  }
};
</script>
